import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false
})
export class ConfirmationDialogComponent {
  @Input() height: string | number = 300;
  @Input() showModal = false;
  @Input() options: ConfirmationDialogData | null = null;
  @Input() hideDismissButton: boolean = false;

  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter();

  dismiss = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };

  onSubmit = () => {
    this.submit.emit();
  };
}

export interface ConfirmationDialogData {
  submitButtonText?: string;
  message?: string;
  title?: string;
  hideUndo?: boolean;
  dismissButtonText?: string;
}
